import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
import { AdUser } from 'src/app/core/api.gen';

@Component({
  selector: 'eos-copyable-field-wrapper',
  template: `
    <div class="form-group" [class.has-error]="showError">
      <label *ngIf="to.label && to.hideLabel !== true" [attr.for]="id">
        {{ to.label }}
        <span *ngIf="to.required && to.hideRequiredMarker !== true">*</span>
      </label>
      <div class="inner-addon right-addon">
        <a *ngIf="hasValue" class="rmv-btn glyphicon">
          <img title="copy" (click)="copyText()" class="ml-1 me-2 dark dark-custom" src="design/images/copy.png">
          <img title="copy" (click)="copyText()" class="ml-1 me-2" src="design/images/copy-light.png">
        </a>
        <ng-template #fieldComponent></ng-template>
      </div>
      <div *ngIf="showError" class="invalid-feedback" [style.display]="'block'">
        <formly-validation-message [field]="field"></formly-validation-message>
      </div>
      <small *ngIf="to.description" class="form-text text-muted">{{ to.description }}</small>
    </div>
  `,
})
export class CopyableFieldWrapperComponent extends FieldWrapper {

  public get hasValue(): boolean {
    return !!this.formControl.value;
  }

  public copyText() {
    if (this.formControl.value) {
      const payload = this.getTextToCopy();
      if (payload && payload.length > 0) {
        const listener = (e: ClipboardEvent) => {
          const clipboard = e.clipboardData || window['clipboardData'];
          clipboard.setData("text", payload);
          e.preventDefault();
        };

        document.addEventListener("copy", listener, false);
        document.execCommand("copy");
        document.removeEventListener("copy", listener, false);
      }
    }
  }

  public getTextToCopy() {
    let copyText = '';
    switch (this.field.type) {
      case 'ad-typeahead':
        const aduser: AdUser = this.formControl.value;
        if (aduser) {
          copyText = `${aduser.displayName} <${aduser.userPrincipalName}>`;
        }
        break;

      case 'select':
      default:
        const data = this.to.options;
        if (data) {
          data.forEach(element => {
            if (copyText === '') {
              for (const ele of element) {
                if (ele && ele[this.to.valueProp] == this.formControl.value) {
                  copyText = ele[this.to.labelProp];
                  break;
                }
              }
            }
          });
        }
        break;
    }

    return copyText;
  }
}
